
import axios from 'axios';
import * as ENDPOINTS from './const';
import querystring from 'querystring';

let cachedSearchString;


class ApiFactory {

  static genEndpoint(method, payload) {
    // retrive resource, data from payload
    // also retrive id for delete api call
    const {resource, custom_action, data, id} = payload;

    /*eslint import/namespace: ['error', { allowComputed: true }]*/
    const ENDPOINT = ENDPOINTS[resource];

    const queryStrings = data ? `?${querystring.stringify({...data})}` : '';

    switch(method) {
      case 'GET' :
        // retrive single resource if id has been supllied
        if (custom_action && id) return axios.get(ENDPOINT+`/${custom_action}/${id}`);
        if (custom_action) return axios.get(ENDPOINT+`/${custom_action}/`);
        if (id) return axios.get(ENDPOINT+`/${id}`);
        return axios.get(ENDPOINT+queryStrings);
      case 'POST' :
        if (custom_action) return axios.post(ENDPOINT+`/${custom_action}`, data);
        return axios.post(ENDPOINT, data);
      case 'PUT' :
        if (custom_action) return axios.put(ENDPOINT+`/${custom_action}`, data);
        return axios.put(ENDPOINT, data);
      case 'DELETE' :
        if (custom_action) return axios.delete(ENDPOINT+`/${custom_action}/${id}`);
        return axios.delete(`${ENDPOINT}/${id}`);
      default:
        return ENDPOINT;
    }
  }

  static get(payload) {

    return this.genEndpoint('GET', payload)
      .then(response => response.data)
      .then((data) => {
        return data.data;
      })
      .catch((error) => {
        throw(error);
      });
  }

  static save({HTTP_METHOD, ...payload}) {
    return this.genEndpoint(HTTP_METHOD, payload)
      .then(response => response.data)
      .then((data) => {
        if (data.success) return data.data;
        throw(data.errors);
      })
      .catch((error) => {
        throw(error);
      });
  }

  static delete(payload) {
    return this.genEndpoint('DELETE', payload)
      .then(response => response.data)
      .then((data) => {
        if (data.success) return data.data;
        throw(data.errors);
      })
      .catch((error) => {
        throw(error);
      });
  }

}

export default ApiFactory;



// WEBPACK FOOTER //
// ./src/api/ApiFactory.js